import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {
    fetchUserSession,
    loadSession,
    resetSession,
    saveStateToSession,
    fetchExistingBooking,
    fetchDraft,
    fetchOptimalle,
    fetchDraftCount,
    unload,
    getSessionContent,
    addSessionToDraft
} from '../../../data/booking/actions/booking';
import {
    getIsLoadingApp,
    getCustomer,
    getIsFetchingDraft,
    getIsFetchingDraftSuccessful,
    getDraftCount,
} from '../../../data/booking/selectors/booking';
import { loadHike } from '../../../data/booking/actions/map';
import App from '../../booking/components/App';
import { withTranslation } from "react-i18next";
import { subscribe } from 'redux-subscriber';
import withRouter from '../../../data/shared/withRouter'
import { isEmpty } from "lodash";
import { PageLoader } from "../../shared/components/PageLoader";
import { getUser, isFetchingUser } from "../../../data/account/selectors/user";
import { NotFound } from "../../booking/components/ErrorPages/404";
import { Forbidden } from "../../booking/components/ErrorPages/403";
import { Navigate } from "react-router-dom";
import { generate } from "../../../routing/routes";
import MatchingBookingAlert from "../../booking/components/MatchingBookingAlert";
// import { normalizeStep } from "data/booking/normalizers/bag_transport";

class AppContainer extends Component {
    static propTypes = {
        isLoading: PropTypes.bool,
        isFetchingCurrentUser: PropTypes.bool,
        customer: PropTypes.object,
        user: PropTypes.object,
        fetchUserSession: PropTypes.func,
        fetchExistingBooking: PropTypes.func,
        addSessionToDraft: PropTypes.func,
        fetchDraft: PropTypes.func,
        fetchOptimalle: PropTypes.func,
        loadSession: PropTypes.func,
        loadHike: PropTypes.func,
        router: PropTypes.object
    };

    unsubscribe = null;

    state = {
        match: false,
    }

    // constructor(props) {
    //     super(props);
    //     const { reference } = props.router.params
    //     if (props.router.location.pathname.includes("optimalle")) {
    //         // console.log("haaaaaaaaaaaaaaaaaaaaaaaa", JSON.parse(props.router.searchParams.get("items")));
    //         // location.replace("/fr/book");
    //         let stepBag = props.router.searchParams.getAll("items[bag-transport]");
    //         let stepPeople = props.router.searchParams.getAll("items[people-transport]");
    //         let stepBike = props.router.searchParams.getAll("items[bike-transport]");
    //         let step = {};
    //         if(stepBag.length>0){
    //             // step["bag-transport"].push(stepBag)
    //             step={"bag-transport":stepBag}
    //         }
    //         if(stepPeople.length>0){
    //             step={...step,"people-transport":stepPeople}
    //         }
    //         if(stepBike.length>0){
    //             step={...step,"bike-transport":stepBike}
    //         }
    //         console.log(step, reference)
    //         props.fetchOptimalle(reference, props.router)
    //         .then((response)=>{
    //             // console.log("okkkkkkkkkkk",response);
    //         location.replace("/fr/book")
    //     });

    //     }
    // }

    componentDidMount() {
        const { reference } = this.props.router.params
        if (!isEmpty(reference) && this.props.router.location.pathname === generate('book_optimalle', {reference})) {

            this.props.fetchUserSession();
            this.props.fetchOptimalle(reference, this.props.router.searchParams)
            .then(()=>{
                this.props.router.navigate(generate("book"), { replace: true })
            });
        }
        else {

            if (!isEmpty(reference)) {
                this.props.fetchDraft(reference);
            }
            this.props.fetchUserSession();
            this.props.loadSession().then(action => {
                if (action.state) {
                    this.props.fetchExistingBooking().then(action => {
                        this.setState({
                            match: action.match
                        })
                    })
                }
            })
            this.unsubscribe = subscribe('booking.booking.entities', saveStateToSession)
        }
    }

    componentDidUpdate(prevProps) {
        const { reference } = this.props.router.params

        if (reference && !prevProps.router.params.reference && this.state.match) {
            this.setState({ match: false })
            const session = getSessionContent();
            this.props.fetchDraft(reference).then(() => {
                this.props.addSessionToDraft(session)
            });
        }
        if (!isEmpty(this.props.user) && this.props.user !== prevProps.user && isEmpty(reference) && this.props.user.type != "business") {
            this.props.fetchDraftCount();
        }
    }

    componentWillUnmount() {
        this.unsubscribe != null && this.unsubscribe()
        resetSession();
        this.props.unload()
    }

    render() {
        const { isLoading, isFetchingDraft, isFetchingDraftSuccessful, isFetchingCurrentUser, user, draftCount, t } = this.props;
        const { match } = this.state

        if (isLoading || isFetchingDraft || isFetchingCurrentUser) {
            return <PageLoader />
        }

        if (draftCount >= 3 && user.type != "business") {
            return <Navigate to={generate('account_dashboard')} replace={true} />
        }

        const { reference } = this.props.router.params

        //création de devis
        if (isEmpty(reference) || isFetchingDraftSuccessful !== false) {
            return (
                <>
                    <MatchingBookingAlert bookings={match} setOpen={() => { this.setState({ match: false }) }} />
                    <App />
                </>
            );
        }

        // sinon edition mais pas connecté
        if (isEmpty(user)) {
            return <Forbidden />
        }

        //sinon edition mais brouillon introuvable
        return <NotFound />
    }
}

export default compose(withTranslation(), connect(
    state => ({
        isLoading: getIsLoadingApp(state.booking),
        isFetchingDraft: getIsFetchingDraft(state.booking),
        isFetchingDraftSuccessful: getIsFetchingDraftSuccessful(state.booking),
        draftCount: getDraftCount(state.booking),
        isFetchingCurrentUser: isFetchingUser(state),
        customer: getCustomer(state.booking),
        user: getUser(state)
    }),
    dispatch => bindActionCreators({ addSessionToDraft, fetchDraftCount, fetchUserSession, loadSession, fetchDraft, unload, fetchOptimalle, fetchExistingBooking, loadHike }, dispatch)
))(withRouter(AppContainer));
